import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-approval-menu',
    templateUrl: './approval-menu.component.html',
    styleUrls: ['./approval-menu.component.scss'],
    standalone: false
})
export class ApprovalMenuComponent {
  @Input() recordStatus: string;
  @Input() recordType: string;
  @Output() toggleStatus = new EventEmitter();
}
